import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const BidderCtrTable = ({ report }) => {
    const rows = report.map(row => <Row {...row} key={row.country}/>);

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th>Country</th>
                <th>Cpc</th>
            </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
};

export default BidderCtrTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderCpcCountry/components/Table/index.js